// Home.js
import "./home.css";
import { useState } from "react";
import banner from "./banner.png";
import expert from "./expert.png";
import time from "./time.png";
import centric from "./centric.png";
import transparent from "./transparent.png";
import support from "./support.png";
import website from "./website.png";
import googleseo from "./googleseo.png";
import googlemap from "./googlemap.jpg";


const sections = [
  {
    image: website,
    title: "Why Your Business Needs a Website",
    content: "In today's digital era, having a professional website is crucial for business growth. A website serves as your digital storefront, allowing customers to find you anytime, anywhere. It enhances credibility, increases customer engagement, and provides a platform to showcase your services and products. Without a website, your business may miss out on countless opportunities to grow and expand."
  },
  {
    image: googleseo,
    title: "The Power of Google SEO",
    content: "Search Engine Optimization (SEO) is essential for businesses to improve their online visibility. A well-optimized website ranks higher on search engines like Google, attracting more potential customers. SEO helps businesses appear in relevant searches, drives organic traffic, and increases brand credibility. Ignoring SEO means losing potential clients to competitors who invest in their online presence."
  },
  {
    image: googlemap,
    title: "Boost Your Local Reach with Google Maps",
    content: "Google Maps is a game-changer for local businesses. By listing your business on Google Maps, you make it easier for customers to find you. It increases foot traffic, improves search rankings, and builds trust among potential clients. A strong Google Maps presence, combined with positive reviews, ensures your business stands out in local searches and attracts more customers."
  }
];

const whyChooseUsData = [
  {
    title: "Experienced Team",
    heading: "Expertised Team",
    content: "Our team of experienced experts creates cutting-edge software solutions to drive success for businesses. With a passion for technology and commitment to delivering the best possible customer experience, we are a trusted partner for your software needs.",
    image: expert,
  },
  {
    title: "On-Time Delivery",
    heading: "Timely Deliveries",
    content: "At our software company, we deliver custom software solutions on time, every time. Our team of experts is committed to delivering high-quality products that meet the unique needs of each of our clients.",
    image: time,
  },
  {
    title: "Customer-Centric Approach",
    heading: "Customer Focused",
    content: "At our software company, we prioritize our clients’ needs and strive to deliver exceptional customer experiences. Our team takes a customer-centric approach, working closely with each client to understand their specific requirements and delivering custom software solutions that drive success.",
    image: centric,
  },
  {
    title: "Transparency",
    heading: "Open & Transparent",
    content: "We believe in transparency and open communication at our software company. Our team of experts keeps our clients informed every step of the way, ensuring a smooth and seamless software development process.",
    image: transparent,
  },
  {
    title: "Hassle-Free Support",
    heading: "Seamless Support",
    content: "We provide hassle-free support to ensure our clients receive the best possible customer experience. Our team of experts is dedicated to delivering ongoing support and maintenance, making sure our clients’ software solutions run smoothly and efficiently.",
    image: support,
  },
];

const Home = () => {
  const [selected, setSelected] = useState(whyChooseUsData[0]);

  return (
    <>
       <header className="welcome-note">
        <img src={banner} alt="banner"/>
        <section>
        <h1>Get More Leads and Accelerate Your Growth</h1>
        <p>Utilize our services to take your business to the next level.</p>
        </section>
      </header>
   
      {sections.map((section, index) => (
        <section key={index} className={`why-section ${index % 2 === 0 ? "image-left" : "image-right"}`}>
          <img src={section.image} alt={section.title} className="section-image" />
          <div className="section-content">
            <h2>{section.title}</h2>
            <p>{section.content}</p>
          </div>
        </section>
      ))}

    <div className="home-container">
   
       <h2>Why Choose Us</h2>
        <p style={{width:"85%",margin:"auto",textAlign:"justify",fontSize:"16px"}}>We offer a unique combination of innovation, expertise, and customer focus. Our team of experienced developers creates cutting-edge software solutions to help businesses achieve their goals. With a passion for technology and a commitment to delivering the best possible customer experience, we stand out as a partner you can trust for your growth.</p>
        
      
      <section>
        <div className="why-choose-content">
          <div className="why-choose-left">
            {whyChooseUsData.map((item, index) => (
              <button key={index} onClick={() => setSelected(item)}>
                {item.title}
              </button>
            ))}
          </div>
          <div className="why-choose-right">
            <img className="choose-us-img" src={selected.image} alt={selected.title} />
            <h2>{selected.heading}</h2>
            <p>{selected.content}</p>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default Home;